var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { C } from '#integrations';
import { Typography } from '../../../../Typography';
import styles from './ListBoxOption.module.css';
export const ListBoxOption = ({ 'data-testid': testId, disabled = false, isSelected, onClick, option, ref, tabIndex, }) => {
    const handleClick = (event) => {
        event.preventDefault();
        if (!disabled) {
            onClick();
        }
    };
    return (_jsx("div", { "aria-disabled": disabled, "aria-selected": isSelected, className: C(styles.Container, isSelected && styles.OptionSelected, disabled && styles.OptionDisabled), "data-testid": testId, onClick: handleClick, ref: ref, role: "option", tabIndex: tabIndex, children: _jsx(Typography, { align: "center", kind: "generic-small", children: option.text }) }));
};
_react_refresh_temp_1 = ListBoxOption;
$RefreshReg$(_react_refresh_temp_1, "ListBoxOption");
